import React from 'react'
import {withRouter} from 'react-router';
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import ChipUserAccount from "../../components/ChipUserAccount";
import Grid from "@material-ui/core/Grid";
import CuentaSelected from "../../helpers/CuentaSelected";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import InvoicesList from "./InvoicesList";
import Chart from "react-apexcharts";
import {FormatNumber, GetNameMonth} from "../../helpers/Helpers";

class Invoices extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            invoicesList: [],
            series: [],
            options: {
                plotOptions: {
                    bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                    },
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                xaxis: {
                    categories: [],
                },
                yaxis: {
                    title: {
                        text: '($) Valor'
                    }
                },
                fill: {
                    opacity: 1
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `$ ${FormatNumber.new(val)}`
                        }
                    }
                }
            },
        };
    }

    async componentDidMount() {
        await this.getInvoices();
    }

    getInvoices = async () => {
        const account = CuentaSelected.get()
        const data = await Api.get(`${Env.UrlSeguridad}/getVFacturaWeb/${account.cuentaCodigo}`);
        if (data.cod === '1') {
            this.setState({
                invoicesList: data.V_factura_WEB,
            });
            this.setDataChart(data.V_factura_WEB);
        }
    }

    setDataChart = (data) => {

        // Configuro la data
        let dataSeries = [];
        for (let i = 0; i < data.length; i++) {
            const obj = data[i];
            dataSeries.push(obj.VALOR);
        }

        // Configuro los labels
        let categories = [];
        for (let i = 0; i < data.length; i++) {
            const obj = data[i];
            const val = `${obj.ANO} - ${GetNameMonth(obj.MES)}`;
            categories.push(val);
        }

        // Se asignan al estado del diagrama de barras
        this.setState({
            series: [
                {
                    name: 'Total facturado',
                    data: dataSeries
                }
            ],
            options: {
                xaxis: {
                    categories: categories
                }
            }
        });
    }

    render() {
        return (
            <div style={{minHeight: '500px', textAlign: 'center'}}>

                <AppBreadcrumbs
                    links={[
                        {
                            url: 'accounts',
                            label: 'Cuentas'
                        },
                        {
                            url: 'menu',
                            label: 'Menú'
                        }
                    ]}
                    actual='Facturas'
                />

                <h2>
                    <ChipUserAccount/>
                    <span>Facturas</span>
                </h2>



                <Grid container>
                    <Grid item xs={6} style={{padding: '20px'}}>
                        <InvoicesList data={this.state.invoicesList}/>
                    </Grid>
                    <Grid item xs={6} style={{padding: '20px'}}>
                        <Chart options={this.state.options} series={this.state.series} type="bar" height={300}/>
                    </Grid>
                </Grid>

            </div>
        );
    }
}

export default withRouter(Invoices)